export default __webpack_public_path__ + "static/media/manyou.6919d134.png";